import { useEffect, useMemo, useQuery } from 'sb-hooks'
import { useForm } from 'formular'
import { required } from 'helpers/validation'
import { snowplow } from 'common/helpers'

import unsubscribeReasonsQuery from './unsubscribeReasons.graphql'


const useUnsubscribeReasonModalBase = () => {
  useEffect(() => {
    snowplow.track('UF reason popup')
  }, [])

  const form = useForm<UnsubscribeReasonModal.FormValues>({
    fields: {
      reason: [ required ],
      comments: [],
    },
    initialValues: {
      reason: '',
      comments: '',
    },
  })

  const reasonsQueryOptions = useMemo(() => ({
    name: 'unsubscribeReasons',
    modifyResult: (data) => data.unsubscribeReasons,
  }), [])

  const { data: reasons, isFetching } = useQuery<UnsubscribeReasonModal.Reason[]>(unsubscribeReasonsQuery, reasonsQueryOptions)

  return {
    form,
    reasons,
    isFetching,
  }
}


export default useUnsubscribeReasonModalBase
